import { CSS } from "../../constants/css";

const instance = ($el: HTMLElement) => {
  let timeoutId: number | undefined;
  const hoverClass = CSS.hovered;
  const jsInitialisedClass = CSS.initialised;
  const delay = 3000;

  setTimeout(() => {
    $el.classList.add(jsInitialisedClass);
  }, delay);

  $el.addEventListener("mouseenter", () => {
    clearTimeout(timeoutId);
    $el.classList.add(hoverClass);
  });

  $el.addEventListener("mouseleave", () => {
    timeoutId = setTimeout(() => {
      $el.classList.remove(hoverClass);
    }, delay);
  });
};

export default () => {
  const $globalHeaders = document.querySelectorAll<HTMLElement>(".js-global-header");
  $globalHeaders.forEach(($el) => {
    instance($el);
  });
};
